/**
 * Number / currency / percentage formatters for Ads Manager tables.
 */

export function formatCurrency(value: number | null | undefined): string {
  if (value == null || !Number.isFinite(value)) return "$0.00"
  return "$" + Number(value).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}

export function formatNumber(value: number | null | undefined): string {
  if (value == null || !Number.isFinite(value)) return "0"
  return Number(value).toLocaleString("en-US", {
    maximumFractionDigits: 2,
  })
}

export function formatPercent(value: number | null | undefined): string {
  if (value == null || !Number.isFinite(value)) return "0.00%"
  return Number(value).toFixed(2) + "%"
}

export function formatRoi(value: number | null | undefined): string {
  if (value == null || !Number.isFinite(value)) return "N/A"
  return Number(value).toFixed(2) + "%"
}

/**
 * Format a cell value based on column ID.
 */
export function formatCellValue(
  columnId: string,
  value: unknown,
): string {
  const num = Number(value)
  switch (columnId) {
    case "cost":
    case "revenue":
    case "profit":
    case "budget":
    case "bid":
    case "cpc":
    case "cpm":
    case "cpa":
    case "rpc":
    case "rpm":
      return formatCurrency(Number.isFinite(num) ? num : null)
    case "roi":
      return formatRoi(Number.isFinite(num) ? num : null)
    case "ctr":
    case "cvr":
    case "one_to_two_flow":
      return formatPercent(Number.isFinite(num) ? num : null)
    case "p1_cvr":
    case "p2_cvr":
      if (value == null || !Number.isFinite(num)) return "N/A"
      return formatPercent(num)
    case "status":
      return String(value ?? "")
    default:
      return formatNumber(Number.isFinite(num) ? num : null)
  }
}
